import { COMPANY_NAME } from '@common'
import React from 'react'
import { Outlet } from 'react-router-dom'

const MembershipLayout = () => {
    return (
        <div className="membership-layout">
            {/* Main Content */}
            <div className="membership-content">
                <Outlet />
            </div>

            {/* Footer */}
            <div className="membership-footer">
                <div className="text-center text-muted p-4">
                    <p className="mb-0">
                        &copy; {new Date().getFullYear()}，{COMPANY_NAME}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default MembershipLayout
